var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardicon03(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_77_78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.2356 18.3474C46.2356 19.2854 45.4763 20.0447 44.5383 20.0447H8.58301C7.64505 20.0447 6.88574 19.2854 6.88574 18.3474C6.88574 17.4095 7.64505 16.6501 8.58301 16.6501H44.5383C45.4763 16.6501 46.2356 17.4095 46.2356 18.3474Z",
    fill: "#E9E6D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.88574 43.3598C6.88574 42.4218 7.64505 41.6625 8.58301 41.6625H44.5383C45.4763 41.6625 46.2356 42.4218 46.2356 43.3598C46.2356 44.2978 45.4763 45.0571 44.5383 45.0571H8.58301C7.64505 45.0571 6.88574 44.2978 6.88574 43.3598Z",
    fill: "#E9E6D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0149 21.072H9.78906V23.5732H15.0149V21.072Z",
    fill: "#E9E6D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0149 37.866H9.78906V40.3673H15.0149V37.866Z",
    fill: "#E9E6D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2555 22.1439H10.5483V39.2953H14.2555V22.1439Z",
    fill: "#E9E6D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.072 21.072H16.8462V23.5732H22.072V21.072Z",
    fill: "#E9E6D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.072 37.866H16.8462V40.3673H22.072V37.866Z",
    fill: "#E9E6D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3571 22.1439H17.6499V39.2953H21.3571V22.1439Z",
    fill: "#E9E6D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.174 21.072H23.9482V23.5732H29.174V21.072Z",
    fill: "#E9E6D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.174 37.866H23.9482V40.3673H29.174V37.866Z",
    fill: "#E9E6D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4147 22.1439H24.7075V39.2953H28.4147V22.1439Z",
    fill: "#E9E6D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2756 21.072H31.0498V23.5732H36.2756V21.072Z",
    fill: "#E9E6D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2756 37.866H31.0498V40.3673H36.2756V37.866Z",
    fill: "#E9E6D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5163 22.1439H31.8091V39.2953H35.5163V22.1439Z",
    fill: "#E9E6D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3327 21.072H38.1069V23.5732H43.3327V21.072Z",
    fill: "#E9E6D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3327 37.866H38.1069V40.3673H43.3327V37.866Z",
    fill: "#E9E6D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5734 22.1439H38.8662V39.2953H42.5734V22.1439Z",
    fill: "#E9E6D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6377 46.1737H6.48389C5.54593 46.1737 4.78662 46.933 4.78662 47.871H48.335C48.335 46.933 47.5757 46.1737 46.6377 46.1737Z",
    fill: "#E9E6D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.48389 15.4888H46.6377C47.5757 15.4888 48.335 14.7295 48.335 13.7916H4.78662C4.78662 14.7295 5.54593 15.4888 6.48389 15.4888Z",
    fill: "#E9E6D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1216 48.8983H3V51.2208H50.1216V48.8983Z",
    fill: "#E9E6D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.55566 12.5856H45.5656L26.583 2L7.55566 12.5856Z",
    fill: "#E9E6D5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_77_78"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.1216,
    height: 49.2208,
    fill: "white",
    transform: "translate(3 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardicon03);
export default __webpack_public_path__ + "static/media/cardicon03.078a8a44bef529ae6eb671b3e3a0dde1.svg";
export { ForwardRef as ReactComponent };